const getPrice = (price, vatInc) => price?.[vatInc ? "taxed" : "untaxed"];
const validatePriceValue = (value, paramName) => {
  if (value !== void 0 && typeof value === "number" && value < 0) {
    throw new Error(`validation failed: ${paramName} invalid value, needs a number greater or equal than 0, current value: ${value}`);
  }
};

export { getPrice, validatePriceValue };
//# sourceMappingURL=ep-pricing-esm-utils-price.util.js.map
